import React from 'react';

import { SvgIcon } from '@interlayer/js/app/components/common/SvgIcon';

import { clsx } from '@interlayer/js/app/utils/clsx.util';

import { useHandleBackReg } from './hooks/useHandleBackReg';
import { TBackRegArrowProps } from './types';

import style from './BackRegArrow.scss';

export const BackRegArrow: React.FC<TBackRegArrowProps> = ({ isHidden, className }) => {
    const handleBackReg = useHandleBackReg();

    if (!handleBackReg || isHidden) {
        return (
            <span />
        );
    }

    return (
        <SvgIcon
            type="arrow-left"
            className={clsx(style.arrowBack, className)}
            onClick={handleBackReg}
        />
    );
};
